import { render, staticRenderFns } from "./chapterEnd.vue?vue&type=template&id=5db0f8b6&scoped=true"
import script from "./chapterEnd.vue?vue&type=script&lang=js"
export * from "./chapterEnd.vue?vue&type=script&lang=js"
import style0 from "./chapterEnd.vue?vue&type=style&index=0&id=5db0f8b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0f8b6",
  null
  
)

export default component.exports